import { styled } from '@mui/material/styles';
import { Input, Avatar, ListItem, ListItemAvatar, CircularProgress, Chip, IconButton, Tooltip } from '@mui/material'
import SendIcon from '@mui/icons-material/Send';
import CloseIcon from '@mui/icons-material/Close';
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import produce from 'immer';
import Skeleton from '@mui/material/Skeleton';

const PREFIX = 'replyEditForm';

const classes = {
  container: `${PREFIX}-container`,
  root: `${PREFIX}-root`,
  progress: `${PREFIX}-progress`,
  avatarSection: `${PREFIX}-avatarSection`,
  inputSection: `${PREFIX}-inputSection`,
  inputRoot: `${PREFIX}-inputRoot`,
  button: `${PREFIX}-button`,
  buttons: `${PREFIX}-buttons`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.container}`]: {
		flexGrow:1
  },

  [`& .${classes.root}`]: {
		display:'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    //alignItems: 'center',
  },

  [`& .${classes.progress}`]: {
    textAlign: 'center',
  },

  [`& .${classes.avatarSection}`]: {
    padding: '10px',
    marginTop: '5px',
  },

  [`& .${classes.inputSection}`]: {
    padding: '5px',
    width: '100%',
  },

  [`& .${classes.inputRoot}`]: {
		width: '100%',
		fontSize: 14,
  },

  [`& .${classes.button}`]: {
    marginLeft: theme.spacing(2),
  },

  [`& .${classes.buttons}`]: {
		display: 'flex',
		justifyContent: 'flex-end',
  }
}));

export default props => {

	const root = useSelector(state => state.api).root;
	const user = useSelector(state => state.user);
	const dispatch = useDispatch();
	const [ loading, setLoading ] = useState(false);
	const { reply, updateReply, setIsEditFormClicked } = props;
	const [ input, setInput ] = useState(reply.text);
	const [ persontags, setPersontags ] = useState(reply.persontags);

	const handleEditSubmit = () => {
    if(input === '') return;
		setLoading(true);
		fetch(`${root}/api/reply/${reply._id}`, { 
			method: 'put', 
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({ text: input }), 
			credentials: 'include' 
		})
			.then(res => {
				setLoading(false);
				console.log('replyEdit success', res)
				updateReply(draft => {
					draft.text = input; 
				});
				handleEditFormCancle();
			})
			.catch(err => console.log(err))
	};

	const handleEditFormCancle = () => {
		setIsEditFormClicked(false);
	};

  return (
    <Root>
        {
            loading
            ?
      <div className={classes.root}>
        <div className={classes.avatarSection}>
          <Skeleton animation="wave" variant="circular" width={40} height={40} />
        </div>
                    <div style={{width: '100%', margin: '5px', paddingTop: '20px', alignText: 'center'}}>
          <Skeleton animation="wave" height={10} width="100%"  />
                    </div>
      </div>
    :
      <div className={classes.root}>
        <div className={classes.avatarSection}>
          <Avatar className={classes.avatar} alt="Remy Sharp" src={user.profileImageUrl}/>
        </div>
                    <div className={classes.inputSection}>
          <div align='left'>
            {(reply.persontags ?? []).map(persontag => <Chip label={'@'+persontag.username} />)}
          </div>
                        <Input
                            defaultValue={reply.text}
                            className={classes.inputRoot}
            multiline
                            inputProps={{
                                'aria-label': 'description',
                                 classes: {
                                     input: classes.input,
                                 },
                            }}
                            onChange={e => setInput(e.target.value)}
            onKeyDown={ev => {
              /*
              if(ev.key === 'Enter'){
                handleEditSubmit();
              }
              */
              if(ev.keyCode === 27){
                handleEditFormCancle()
              }
            }}
                        />
                        <div className={classes.buttons} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 6 }}>
                            <Tooltip title="Save">
                              <IconButton size="small" aria-label="Save" onClick={handleEditSubmit}>
                                <SendIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Cancel">
                              <IconButton size="small" aria-label="Cancel" onClick={handleEditFormCancle}>
                                <CloseIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                        </div>
                    </div>
                </div>
        }
    </Root>
  );
}
				


